import { render, staticRenderFns } from "./Knit.vue?vue&type=template&id=23ae160e&scoped=true"
import script from "./Knit.vue?vue&type=script&lang=js"
export * from "./Knit.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/inbox.css?vue&type=style&index=0&id=23ae160e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ae160e",
  null
  
)

export default component.exports